// Anti-bot protection for Shopify checkout
const antiBot = {
    // Minimum price threshold (in cents)
    MIN_PRICE: 100, // $1.00
  
    // Initialize protection
    init() {
      this.addCustomPriceValidation();
      this.addHoneypot();
      this.implementRateLimit();
    },
  
    // Add custom price validation to prevent $0 checkouts
    addCustomPriceValidation() {
      document.addEventListener('submit', (event) => {
        if (event.target.matches('form[action="/cart/add"]')) {
          const priceElement = event.target.querySelector('.price-item--regular');
          if (priceElement) {
            const price = parseInt(priceElement.getAttribute('data-price'));
            if (price < this.MIN_PRICE) {
              event.preventDefault();
              alert('Invalid price detected. Please contact support if you think this is an error.');
            }
          }
        }
      });
    },
  
    // Add honeypot field to catch basic bots
    addHoneypot() {
      const honeypotField = document.createElement('div');
      honeypotField.style.opacity = '0';
      honeypotField.style.position = 'absolute';
      honeypotField.style.top = '-9999px';
      honeypotField.innerHTML = `
        <input type="text" 
               name="bot_trap"
               tabindex="-1"
               autocomplete="off">
      `;
  
      document.querySelectorAll('form[action="/cart/add"]').forEach(form => {
        form.appendChild(honeypotField.cloneNode(true));
        form.addEventListener('submit', (event) => {
          const botTrap = event.target.querySelector('[name="bot_trap"]');
          if (botTrap && botTrap.value) {
            event.preventDefault();
            console.log('Bot detected via honeypot');
          }
        });
      });
    },
  
    // Implement rate limiting for add to cart actions
    implementRateLimit() {
      const RATE_LIMIT = {
        maxAttempts: 5,
        timeWindow: 60000, // 1 minute
        attempts: new Map()
      };
  
      document.addEventListener('submit', (event) => {
        if (event.target.matches('form[action="/cart/add"]')) {
          const now = Date.now();
          const clientIP = '{{client_ip}}'; // Shopify liquid variable
          const attempts = RATE_LIMIT.attempts.get(clientIP) || [];
          
          // Clean up old attempts
          const recentAttempts = attempts.filter(timestamp => 
            now - timestamp < RATE_LIMIT.timeWindow
          );
          
          if (recentAttempts.length >= RATE_LIMIT.maxAttempts) {
            event.preventDefault();
            alert('Too many attempts. Please try again later.');
            return;
          }
          
          recentAttempts.push(now);
          RATE_LIMIT.attempts.set(clientIP, recentAttempts);
        }
      });
    }
  };